import { PartnerBadgeEnum } from "@/types";
import { useFarbwelt } from "../useFarbwelt";
import { useClassified, useHardFacts } from "@/contexts/classified";
const badgeMappings = {
    [PartnerBadgeEnum.platin]: "loyalty-platinum",
    [PartnerBadgeEnum.diamond]: "loyalty-diamond",
    [PartnerBadgeEnum.simple]: "loyalty-immowelt",
    [PartnerBadgeEnum.business]: "loyalty-business",
    [PartnerBadgeEnum.premium]: "loyalty-premium",
};
export const useTrackingPromotion = () => {
    var _a, _b, _c, _d, _e, _f, _g;
    const { isFarbweltActive } = useFarbwelt();
    const badges = (_c = (_b = (_a = useClassified()) === null || _a === void 0 ? void 0 : _a.contactSections) === null || _b === void 0 ? void 0 : _b.provider) === null || _c === void 0 ? void 0 : _c.badges;
    const isHdExclusive = (_e = (_d = useClassified()) === null || _d === void 0 ? void 0 : _d.tags) === null || _e === void 0 ? void 0 : _e.isHdExclusive;
    const previousPrice = (_g = (_f = useHardFacts()) === null || _f === void 0 ? void 0 : _f.price) === null || _g === void 0 ? void 0 : _g.previousPrice;
    if (!isFarbweltActive && !(badges === null || badges === void 0 ? void 0 : badges.length) && !isHdExclusive && !previousPrice)
        return undefined;
    const promotions = isFarbweltActive ? ["farbwelt"] : [];
    if (badges === null || badges === void 0 ? void 0 : badges.length) {
        const badgePromotions = badges
            .map((badge) => badgeMappings[badge.title])
            .filter(Boolean);
        if (badgePromotions.length) {
            promotions.push(...badgePromotions);
        }
    }
    if (isHdExclusive) {
        promotions.push("IWT_exclusive");
    }
    if (previousPrice) {
        promotions.push("price_drop");
    }
    return promotions.length ? promotions.join("|") : undefined;
};
